import Link from "next/link";
import { modifyImageUrlQueryParams } from "@JohnLewisPartnership/jl-design-system/dist/utils/imageUrlModifier/imageUrlModifier";
import classNames from "classnames/bind";
import styles from "./Swatch.module.scss";
import { ColourOption } from "@/components/Colours/types.ts";
import { SaleTag } from "@/components/Colours/ColourList/Swatches/Swatch/SaleTag/SaleTag.tsx";
import {
  SWATCHES_SELECT_COLOUR,
  SWATCHES_SELECT_POSITION_1_5,
  SWATCHES_SELECT_PROMO_COLOUR,
  SWATCHES_SELECT_POSITION_11_PLUS,
  SWATCHES_SELECT_POSITION_6_10,
} from "@/components/Colours/ColourList/monetateEvents.ts";
import { sendEvent } from "@JohnLewisPartnership/experiments-utils";
const cx = classNames.bind(styles);

type SwatchProps = {
  colourIndex: number;
  colour: ColourOption;
  isDior: boolean;
  replaceHistoryEntryOnColourChange: boolean;
};

const handleSwatchClick = (colour: ColourOption, colourIndex: number) => {
  sendEvent(SWATCHES_SELECT_COLOUR);

  if (colour.showReduced) {
    sendEvent(SWATCHES_SELECT_PROMO_COLOUR);
  }

  if (colourIndex >= 0 && colourIndex <= 4) {
    sendEvent(SWATCHES_SELECT_POSITION_1_5);
  } else if (colourIndex >= 5 && colourIndex <= 9) {
    sendEvent(SWATCHES_SELECT_POSITION_6_10);
  } else {
    sendEvent(SWATCHES_SELECT_POSITION_11_PLUS);
  }
};

export const Swatch = ({
  colour,
  isDior,
  colourIndex,
  replaceHistoryEntryOnColourChange,
}: SwatchProps) => {
  let additionalInformation = "";

  if (!colour.showAsAvailable) {
    additionalInformation = " - Out of stock";
  } else if (colour.showReduced) {
    additionalInformation = ` - ${colour.reducedLabel}`;
  }

  return (
    <Link
      className={cx("link")}
      aria-label={`${colour.colour} colour${additionalInformation}`}
      aria-selected={colour.selected}
      href={colour.url}
      title={`${colour.colour}${additionalInformation}`}
      role="option"
      shallow
      scroll={false}
      onClick={() => handleSwatchClick(colour, colourIndex)}
      replace={replaceHistoryEntryOnColourChange}
    >
      <span
        className={cx("option", {
          selected: colour.selected,
          notAvailable: !colour.showAsAvailable,
        })}
      >
        <img
          src={modifyImageUrlQueryParams(colour.colourSwatch || "", {
            wid: 34,
            hei: 34,
            sm: "c",
          })}
          alt={colour.colour}
        />
        {colour.showAsAvailable && colour.showReduced && (
          <SaleTag isDior={isDior} />
        )}
      </span>
    </Link>
  );
};
